export class MsgStatusMediaPath {
    public media_speed:number = 0;
    public constructor(init?: Partial<MsgStatusMediaPath>) {
        Object.assign(this, init);
    }
}